export const providersWithRiskDetails = `Os fornecedores com riscos-socioambientais são aqueles que foram consultados em bases de dados e apresentaram algum problema. 

Os problemas consultados são:
- Trabalho análogo à escravidão
- Embargos ambientais
- Situação cadastral não ativa
`

export const finishedItemsTracedToEndSupplierQuantityPropPercentageDetails = `<p>
  A porcentagem exibida no card indica quanto dos produtos cadastrados conseguimos rastrear até a origem. Para isso, combinamos duas formas de rastreabilidade e aplicamos regras simples sobre cada item antes de consolidar o resultado no período escolhido.
</p>

<ul>
  <li>
    <strong>- Rastreabilidade item a item:</strong> cada produto e matéria-prima é ligado diretamente às suas origens; requer integrações ou inserções de dados mais detalhadas.
  </li>
  <br>
  <li>
    <strong>- Rastreabilidade por fornecedores:</strong> quando o item a item não está disponível, usamos declarações nas quais o fornecedor informa quem o abastece e a porcentagem que cada subfornecedor representa.
  </li>
</ul>

<p>
  <strong>Cálculo por produto:</strong><br>
  • 100 % se todos os nós da cadeia chegam ao elo final (fazenda ou frigorífico).<br>
  • 0 % se nenhum nó chega.<br>
  • Proporcional quando apenas parte da cadeia chega.
</p>

<p>
  Primeiro aplicamos o dado item a item; onde não houver, usamos a porcentagem declarada pelo fornecedor. A soma desses valores para todos os produtos gera o percentual global mostrado no card.
</p>
`

export const feedstockItemsTracedToEndSupplierQuantityPropPercentageDetails = `A porcentagem representa a quantidade de matéria-prima que foi rastreada até o início da cadeia.

O valor total utilizado para o cálculo é o total de couro que foi comprado e declarado pelas fábricas.
`

export const finishedItemsQuantitySumDetails = `Quantidade de produtos enviados pelas fábricas.`

export const itemsTransactionHashesQuantitySumDetails = `Quantidade de itens transacionados na blockchain. 

Cada item da cadeia é registrado na blockchain e é considerado nessa conta. A cada nova inserção na cadeia de um item uma nova transação é registrada na blockchain.`

export const finishedItemProfilesQuantitySumDetails = `Quantidade de itens que foram cadastrados na aba QRCode e portanto podem ser visualizados por meio da visão do QRCode. 

No cadastro desses itens temos informações das etapas de produção, origem, descrição e imagem do produto.
`
